import { NgModule } from '@angular/core';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { Table, TableModule, TableService } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TimelineModule } from 'primeng/timeline';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { StepsModule } from 'primeng/steps';
import { ChartModule } from 'primeng/chart';
import { ChipsModule } from 'primeng/chips';
import { ChipModule } from 'primeng/chip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { TabViewModule } from 'primeng/tabview';
import { PasswordModule } from 'primeng/password';
import { InputNumberModule } from 'primeng/inputnumber';
import { GalleriaModule } from 'primeng/galleria';
import { ScrollPanelModule } from 'primeng/scrollpanel';
// import { GMapModule } from 'primeng/gmap';
import { ToolbarModule } from 'primeng/toolbar';
import { FieldsetModule } from 'primeng/fieldset';
import { AccordionModule } from 'primeng/accordion';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PickListModule } from 'primeng/picklist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TreeTableModule } from 'primeng/treetable';
import { SliderModule } from 'primeng/slider';
import { ConfirmationService } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { SplitterModule } from 'primeng/splitter';
import { KeyFilterModule } from 'primeng/keyfilter';

@NgModule({
  declarations: [],
  imports: [
    PanelMenuModule,
    ButtonModule,
    PanelModule,
    TableModule,
    CardModule,
    InputTextareaModule,
    MultiSelectModule,
    CalendarModule,
    PaginatorModule,
    ToastModule,
    DropdownModule,
    AutoCompleteModule,
    CheckboxModule,
    InputTextModule,
    FileUploadModule,
    SelectButtonModule,
    ConfirmDialogModule,
    ToggleButtonModule,
    TimelineModule,
    MessagesModule,
    MessageModule,
    StepsModule,
    ChartModule,
    ChipsModule,
    InputSwitchModule,
    RadioButtonModule,
    TooltipModule,
    SidebarModule,
    DialogModule,
    DividerModule,
    SkeletonModule,
    TagModule,
    TabViewModule,
    PasswordModule,
    InputNumberModule,
    GalleriaModule,
    ScrollPanelModule,
    // GMapModule,
    ToolbarModule,
    FieldsetModule,
    AccordionModule,
    SplitButtonModule,
    PickListModule,
    OverlayPanelModule,
    MenuModule,
    BreadcrumbModule,
    TreeTableModule,
    SliderModule,
    ImageModule,
    ChipModule,
    SplitterModule,
    KeyFilterModule,
  ],
  exports: [
    PanelMenuModule,
    ButtonModule,
    PanelModule,
    TableModule,
    CardModule,
    InputTextareaModule,
    MultiSelectModule,
    CalendarModule,
    PaginatorModule,
    ToastModule,
    DropdownModule,
    AutoCompleteModule,
    CheckboxModule,
    InputTextModule,
    FileUploadModule,
    SelectButtonModule,
    ConfirmDialogModule,
    ToggleButtonModule,
    TimelineModule,
    MessagesModule,
    MessageModule,
    PaginatorModule,
    StepsModule,
    ChartModule,
    ChipsModule,
    InputSwitchModule,
    RadioButtonModule,
    TooltipModule,
    SidebarModule,
    DialogModule,
    DividerModule,
    SkeletonModule,
    TagModule,
    TabViewModule,
    PasswordModule,
    InputNumberModule,
    GalleriaModule,
    ScrollPanelModule,
    // GMapModule,
    ToolbarModule,
    FieldsetModule,
    AccordionModule,
    SplitButtonModule,
    PickListModule,
    OverlayPanelModule,
    MenuModule,
    BreadcrumbModule,
    TreeTableModule,
    SliderModule,
    ImageModule,
    ChipModule,
    SplitterModule,
    KeyFilterModule,
  ],
  providers: [Table, TableService, ConfirmationService],
})
export class PrimeNGImporterModule {}
